/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerUpdateMutationRequest, TemplatesControllerUpdateMutationResponse, TemplatesControllerUpdatePathParams, TemplatesControllerUpdate400, TemplatesControllerUpdate401, TemplatesControllerUpdate403, TemplatesControllerUpdate404 } from "../../models/checklistsController/TemplatesControllerUpdate";

function getTemplatesControllerUpdateUrl(id: TemplatesControllerUpdatePathParams["id"]) {
  const res = { method: 'PATCH', url: `/api/v1/checklist-templates/${id}` as const }  
  return res
}

/**
 * @summary Update a checklist template
 * {@link /api/v1/checklist-templates/:id}
 */
export async function templatesControllerUpdate(id: TemplatesControllerUpdatePathParams["id"], data?: TemplatesControllerUpdateMutationRequest, config: Partial<RequestConfig<TemplatesControllerUpdateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplatesControllerUpdateMutationResponse, ResponseErrorConfig<TemplatesControllerUpdate400 | TemplatesControllerUpdate401 | TemplatesControllerUpdate403 | TemplatesControllerUpdate404>, TemplatesControllerUpdateMutationRequest>({ method : "PATCH", url : getTemplatesControllerUpdateUrl(id).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}